import { render, staticRenderFns } from "./shopBasicInfoAdd.vue?vue&type=template&id=cffc4c20&"
import script from "./shopBasicInfoAdd.vue?vue&type=script&lang=js&"
export * from "./shopBasicInfoAdd.vue?vue&type=script&lang=js&"
import style0 from "./shopBasicInfoAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports